import styled from "styled-components";
import ReactFullpage from "@fullpage/react-fullpage";
import { ServiceAirFreightBackground } from "./ServiceAirFreightBackground";
import { ServiceAirFreightExplanation } from "./ServiceAirFreightExplanation";
import { ServiceAirFreightMissionCapability } from "./ServiceAirFreightMissionCapability";
import { ServiceAirFreightRequestQuote } from "./ServiceAirFreightRequestQuote";
import { ServiceAirFreightAreaOperationSnap } from "./ServiceAirFreightAreaOperation";
import { MainFooter } from "../../Footer/MainFooter";
import { ModalRequestAirFreight } from "../../Modals";
import { RAButtonBackToTop } from "@/components/customs";
import { useRef, useState, useEffect } from "react";
import { ServiceAFIntroduction, ServiceEachRoyalAirFreight } from "./ServiceEachRoyalAirFreight";
import { useHeaderSolid } from "@/hooks/HeaderSolidContext";

const FULL_PAGE_API_KEY = process.env.NEXT_PUBLIC_FULL_PAGE_API_KEY;

export function ServiceAirFreightSnap({ pageContent = {} }) {
	const { content = {} } = pageContent || {};
	const servicesRef = useRef(null);
	const [activeSlide, setActiveSlide] = useState(0);
	const [showRequestAirFreight, setShowRequestAirFreight] = useState(false);
	const { headerSolid } = useHeaderSolid();

	useEffect(() => {
		return () => {
			fullpage_api.silentMoveTo(1);
		};
	}, []);

	const onRequestAirFreight = () => {
		setShowRequestAirFreight(true);
	};

	const onLeave = (origin, destination, direction) => {
		setActiveSlide(destination.index);
		headerSolid(destination.index);
		// arguments are mapped in order of fullpage.js callback arguments do something
		// with the event
		if (direction === "up" && destination.index === 1) {
			setTimeout(function () {
				fullpage_api.moveTo(1);
				fullpage_api.moveSectionDown();
			});
		}
	};

	return (
		<HomepageContainer>
			<div
				ref={servicesRef}
				id="fixed-introduction"
				style={{
					position: "absolute",
					top: "80px",
					opacity: activeSlide >= 2 && activeSlide <= 3 ? 1 : 0,
					transition: "all 0.6s linear",
					zIndex: 100,
					background: "#fff",
					height: "16vh",
					display: "flex",
					alignItems: "flex-end",
				}}
			>
				<ServiceAFIntroduction royal_air_freight={content?.royal_air_freight} />
			</div>
			<ReactFullpage
				licenseKey={FULL_PAGE_API_KEY}
				onLeave={onLeave}
				scrollingSpeed={1100}
				bigSectionsDestination={"top"}
				fadingEffect={true}
				normalScrollElements=".ant-picker-panel-container, .ant-modal, #snap-disabled, .ant-picker-time-panel-column, .mapboxgl-canvas, .ant-modal-wrap, .ra-search-airport-ant-select-dropdown"
				credits={{ enabled: false }}
				lazyLoading={false}
				render={({ state, fullpageApi }) => {
					return (
						<ReactFullpage.Wrapper>
							<div className="section" id="air-freight-hero-section">
								<ServiceAirFreightBackground
									banner={content?.banner}
									onRequestAirFreight={onRequestAirFreight}
								/>
							</div>
							<EachSlide className="section fp-auto-height" id="air-freight-get-in-touch">
								<BodyLargeContainer style={{ height: "auto" }}>
									<ServiceAirFreightExplanation
										what_is_on_demand_air_freight={content?.what_is_on_demand_air_freight}
									/>
								</BodyLargeContainer>
							</EachSlide>
							<EachSlide
								className="section"
								id="jet-one-suite-hero-image"
								style={{ justifyContent: "flex-center" }}
							>
								<BodyLargeContainer
									style={{
										transition: "all 0.6s linear",
										paddingTop: servicesRef?.current?.clientHeight || "50px",
									}}
								>
									<ServiceEachRoyalAirFreight
										royal_air_freight={content?.royal_air_freight}
										step="FIRST"
									/>
								</BodyLargeContainer>
							</EachSlide>
							<EachSlide
								className="section"
								id="jet-one-suite-hero-image"
								style={{ justifyContent: "flex-center" }}
							>
								<BodyLargeContainer
									style={{
										transition: "all 0.6s linear",
										paddingTop: servicesRef?.current?.clientHeight || "50px",
									}}
								>
									<ServiceEachRoyalAirFreight
										royal_air_freight={content?.royal_air_freight}
										step="SECOND"
									/>
								</BodyLargeContainer>
							</EachSlide>
							<EachSlide
								className="section"
								id="air-freight-hero-image"
								style={{
									justifyContent: "flex-center",
									backgroundImage: `url("/images/private-jet-travel/private-jet-travel-mask.png")`,
									backgroundRepeat: "no-repeat",
									backgroundSize: "cover",
								}}
							>
								<BodyExperienceContainer>
									<LayoutOverlay>
										<BodyMediumContainer>
											<ServiceAirFreightMissionCapability
												proven_experience_mission_capability={
													content?.proven_experience_mission_capability
												}
											/>
										</BodyMediumContainer>
									</LayoutOverlay>
								</BodyExperienceContainer>
							</EachSlide>
							<EachSlide
								className="section"
								id="air-freight-hero-image"
								style={{ justifyContent: "flex-center" }}
							>
								<BodyMediumContainer
									style={{
										padding: 0,
									}}
								>
									<ServiceAirFreightAreaOperationSnap
										active={activeSlide === 5}
										our_area_of_operation={content?.our_area_of_operation}
									/>
								</BodyMediumContainer>
							</EachSlide>
							<EachSlide
								className="section fp-auto-height"
								id="footer-section"
								style={{ background: "#fff" }}
							>
								<BodyLargeContainer>
									<ServiceAirFreightRequestQuote
										request_freight_quote={content?.request_freight_quote}
										onRequestAirFreight={onRequestAirFreight}
									/>
								</BodyLargeContainer>
							</EachSlide>
							<EachSlide
								className="section fp-auto-height"
								id="footer-section"
								style={{ background: "#fff" }}
							>
								<footer
									style={{
										width: "100%",
										scrollSnapAlign: "end",
									}}
								>
									<MainFooter />
									<RAButtonBackToTop onClick={() => fullpage_api.moveTo(1)} />
								</footer>
							</EachSlide>
						</ReactFullpage.Wrapper>
					);
				}}
			/>
			<ModalRequestAirFreight visible={showRequestAirFreight} onClose={() => setShowRequestAirFreight()} />
		</HomepageContainer>
	);
}

const LayoutOverlay = styled.div`
	width: 100vw;
	height: 100%;
	background: rgba(249, 249, 249, 0);
	display: flex;
	justify-content: center;
	align-items: flex-start;
`;
const BodyExperienceContainer = styled.div`
	width: 100%;
	display: flex;
	justify-content: center;
`;
const HomepageContainer = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
`;
const EachSlide = styled.div`
	width: 100vw;
	transition: all 0.6s linear;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`;
const BodyLargeContainer = styled.div`
	max-width: 1442px;
	padding: 84px 136px;
	width: 100%;
	@media (max-width: 991px) {
		padding: 40px 80px;
	}
	@media (max-width: 767px) {
		padding: 30px 32px;
	}
	@media (max-width: 575px) {
		padding: 20px;
	}
`;

const BodyMediumContainer = styled.div`
	max-width: 1442px;
	padding: 84px;
	width: 100%;
	@media (max-width: 991px) {
		padding: 44px;
	}
	@media (max-width: 767px) {
		padding: 30px 32px;
	}
	@media (max-width: 575px) {
		padding: 20px;
	}
`;

const BodyJoinTeamContainer = styled.div`
	width: 100vw;
	height: 100vh;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
`;
